import { alpha } from '@mui/system'
import globalTheme, { muiTheme } from '../global'

const SvgIcon = {
	MuiSvgIcon: {
		styleOverrides: {
			root: {
				fontSize: muiTheme.typography.pxToRem(32),
				'&.buttonTextLoading': {
					position: 'absolute',
					top: 0,
					left: 0,
					right: 0,
					margin: 'auto',
					backgroundColor: alpha(globalTheme.palette.primary.contrastText, '0.9'),
					width: '100%',
					height: '100%',
					textAlign: 'center',
				},
				// fix for svg icons with strokes instead of fills
				'&[stroke="currentColor"], :has([stroke="currentColor"])': {
					stroke: 'currentColor',
					fill: 'none',
				},
			},
			fontSizeExtraSmall: {
				fontSize: muiTheme.typography.pxToRem(12),
			},
			fontSizeSmall: {
				fontSize: muiTheme.typography.pxToRem(16),
			},
			fontSizeMiddle: {
				fontSize: muiTheme.typography.pxToRem(18),
			},
			fontSizeMedium: {
				fontSize: muiTheme.typography.pxToRem(24),
			},
			fontSizeButton: {
				fontSize: muiTheme.typography.pxToRem(20),
			},
		},
	},
}

export default SvgIcon
